import dayjs from 'dayjs';

export const isPast = (date, unit = 'second') => dayjs().isAfter(date, unit);
